(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('InstClaimConf', InstClaimConf);

    InstClaimConf.$inject = ['$resource'];

    function InstClaimConf ($resource) {
        var resourceUrl =  'api/inst-claim-confs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT'},
            'filter': {url: 'api/inst-claim-confs/filter', method: 'GET', isArray: true},
        });
    }
})();
